// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aLd2","footer":"styles_footer__aUfve","passCodeTooltip":"styles_passCodeTooltip__30R8R"};